// frontend/src/pages/PortalLogin.jsx (Phase 19)
import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { usePortalAuth } from "../context/PortalAuthContext";
import { suiteApresConnexion } from "../services/b2bApi";
import "../styles/portal.css";

import ForgotPasswordModal from "../components/ForgotPasswordModal";

export default function PortalLogin() {
  const { login } = usePortalAuth();
  const navigate = useNavigate();
  // Retour au tableau de bord B2B après connexion (option B) : pages B2B seulement.
  const [parametres] = useSearchParams();
  const suite = suiteApresConnexion(parametres.get("suite"));
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const { ok } = await login(email.trim().toLowerCase(), password);
    setLoading(false);
    if (ok) navigate(suite || "/portal/dashboard");
    else setError("Email ou mot de passe incorrect.");
  };

  return (
    <div className="pt-root">
      {showForgotModal && <ForgotPasswordModal onClose={() => setShowForgotModal(false)} />}
      <form className="pt-card" onSubmit={submit}>
        <h1 className="pt-title">Connexion</h1>
        <p className="pt-subtitle">Accède à ton espace pro.</p>

        <label className="pt-label">Email</label>
        <input className="pt-input" type="email" value={email}
               onChange={(e) => setEmail(e.target.value)} required />

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <label className="pt-label" style={{ marginBottom: 0 }}>Mot de passe</label>
          <button
            type="button"
            onClick={() => setShowForgotModal(true)}
            style={{ background: "none", border: "none", color: "#00f0ff", fontSize: "0.8rem", cursor: "pointer" }}
          >
            Mot de passe oublié ?
          </button>
        </div>
        <input className="pt-input" type="password" value={password}
               onChange={(e) => setPassword(e.target.value)} required />

        <div className="pt-error">{error}</div>
        <button className="pt-btn pt-btn--primary" disabled={loading}>
          {loading ? "Connexion…" : "Se connecter"}
        </button>
        <div className="pt-foot">
          Pas encore de compte ? <Link className="pt-link" to="/portal/register">S'inscrire</Link>
        </div>
      </form>
    </div>
  );
}
